// ABOUTME: NavBar bell showing the live unread-notification count as a badge.
// ABOUTME: Opens the notification history panel on click; count updates in real time.

import { Badge, IconButton, NotificationsIcon } from '@ds/coolshop';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useNotifications } from '../hooks/useNotifications';
import { NotificationPanel } from './NotificationPanel';

export function NotificationBell() {
    const { formatMessage } = useIntl();
    const [open, setOpen] = useState(false);
    // Default view lists unread only; "Show all" also includes already-read notifications.
    const [showAll, setShowAll] = useState(false);
    const { notifications, unreadCount, loading, markAsRead, markAllAsRead, refetch } =
        useNotifications({
            onlyUnread: !showAll,
        });

    return (
        <>
            <IconButton
                color="primary"
                aria-label={formatMessage({
                    id: 'notifications.title',
                    defaultMessage: 'Notifications',
                })}
                onClick={() => setOpen(true)}
            >
                <Badge badgeContent={unreadCount} color="secondary">
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <NotificationPanel
                open={open}
                onClose={() => setOpen(false)}
                notifications={notifications}
                unreadCount={unreadCount}
                loading={loading}
                showAll={showAll}
                onToggleShowAll={setShowAll}
                onMarkRead={markAsRead}
                onMarkAllRead={markAllAsRead}
                onRefetch={refetch}
            />
        </>
    );
}
